/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const RoofsIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-1114)">
      <g id="Roofs" transform="matrix(0.542569,0,0,0.571048,170.006,377.641)">
        <g transform="matrix(0.632127,-2.57388e-16,-1.00628e-16,0.600602,-1525.62,1291.48)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(2.34169e-17,-0.0462671,0.0785563,0.0001078,44.5043,1398.21)">
          <path
            d="M1773.62,-86.96L1774.36,236.829L2052.05,399.707L1775.07,562.619L1775.89,886.375L1775.07,886.375L1187.68,885.9L1187.51,814.067L1891.99,399.719L1185.54,-14.652L1185.41,-86.485L1662.6,-86.881L1773.62,-86.96ZM1339.41,-18.28L1663.8,171.985L1662.91,-18.542L1339.41,-18.28ZM1664.82,627.467L1341.4,817.695L1664.82,817.957L1664.82,627.467Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(0.280672,2.2183e-32,-6.10033e-32,0.281057,-387.407,1076.37)">
          <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
        </g>
      </g>
    </g>
  </svg>,
  'RoofsIcon',
);
